import { createStore } from 'vuex'
import Sale from './sale'
import User from './user'
import Shelves from './shelves'

export default createStore({
  modules: {
    user: User,
    sale: Sale,
    shelves: Shelves
  }
})
